import React from "react";
import { RatingComponent } from "./Rating";
import { DarkText, GrayText } from "./Text";

export const RatingItem = ({ name, ratingValue, description }) => {
  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      <RatingComponent ratingValue={ratingValue} readOnly={true} />

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <GrayText>{name}</GrayText>
        {/* <GrayText>{date}</GrayText> */}
      </div>
      <DarkText>{description}</DarkText>
    </div>
  );
};
